import { useEffect } from 'react'
import { useGoogleAuth } from '../hooks/useGoogleAuth'

interface GoogleOneTapProps {
  clientId: string
  onSuccess?: () => void
  onError?: (error: Error) => void
  disabled?: boolean
}

export default function GoogleOneTap({
  clientId,
  onSuccess,
  onError,
  disabled = false
}: GoogleOneTapProps) {
  console.log('🔵 GoogleOneTap component rendered with:', { clientId, disabled })
  const { error } = useGoogleAuth({
    clientId,
    enableOneTap: !disabled, // Enable One Tap unless disabled
    onSuccess,
    onError
  })

  // This component doesn't render anything visible
  // It just manages the One Tap functionality
  useEffect(() => {
    if (error) {
      console.log('Google One Tap initialization error:', error)
    }
  }, [error])

  // One Tap is handled automatically by the hook
  // This component is invisible but manages the One Tap prompt
  return null
}